import Bloc from './Bloc.js';
import Types from './Types.js';

export default class Passive extends Bloc {

	constructor (src, ctx) {

		super("passive", src, ctx);
		this.f = (src, ins) => [src.master.player.champion.getPassive(ins[0])];
		this.types = [Types.string];
	}
}